import { render, staticRenderFns } from "./MobileButton.vue?vue&type=template&id=52c59a0c&scoped=true&"
import script from "./MobileButton.vue?vue&type=script&lang=js&"
export * from "./MobileButton.vue?vue&type=script&lang=js&"
import style0 from "./MobileButton.vue?vue&type=style&index=0&id=52c59a0c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c59a0c",
  null
  
)

export default component.exports